import { Heart, CheckCircle2 } from 'lucide-react';
import { Reveal } from '@/components/Reveal';
import { GALLERY_DETAIL_PAGE, GALLERY_FAVORITES, GALLERY_SELECTIONS } from '@/constants/testIds';

const overlayButtonClass = (active) =>
  `absolute top-3 h-10 w-10 flex items-center justify-center rounded-full border backdrop-blur transition-colors duration-200 ${
    active
      ? 'bg-[hsl(var(--lxra-gold))] border-[hsl(var(--lxra-gold))] text-[#0A0A0A]'
      : 'bg-black/50 border-white/20 text-white opacity-0 group-hover:opacity-100 focus-visible:opacity-100 hover:text-[hsl(var(--lxra-gold))]'
  }`;

/**
 * One masonry tile. `realIndex` is the image's position in the full gallery
 * (not the filtered view) so the lightbox opens on the right photo.
 */
export const GalleryImageCard = ({
  image, realIndex, revealDelay, galleryName, onOpen,
  clientMode, isFavorite, isSelected, selectDisabled, selectionLimit,
  onToggleFavorite, onToggleSelection,
}) => (
  <Reveal delay={revealDelay}>
    <div className="group relative overflow-hidden rounded-xl border border-[hsl(var(--lxra-border))] bg-[#141416]">
      <button onClick={onOpen} data-testid={GALLERY_DETAIL_PAGE.image(realIndex)} className="relative block w-full min-h-[180px]">
        <img
          src={image.image_url}
          alt={image.caption || `${galleryName} photo ${realIndex + 1}`}
          loading="eager"
          className="w-full object-cover hover-zoom-img"
        />
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300" />
      </button>
      {clientMode && (
        <>
          <button
            type="button"
            onClick={(e) => { e.stopPropagation(); onToggleFavorite(image); }}
            aria-pressed={isFavorite}
            aria-label={isFavorite ? 'Remove from favorites' : 'Add to favorites'}
            data-testid={GALLERY_FAVORITES.heart(image.id)}
            className={`right-3 ${overlayButtonClass(isFavorite)}`}
          >
            <Heart className={`h-4 w-4 ${isFavorite ? 'fill-current' : ''}`} />
          </button>
          <button
            type="button"
            onClick={(e) => { e.stopPropagation(); if (!selectDisabled) onToggleSelection(image); }}
            disabled={selectDisabled}
            aria-pressed={isSelected}
            aria-label={isSelected ? 'Remove from final picks' : 'Add to final picks'}
            data-testid={GALLERY_SELECTIONS.toggle(image.id)}
            title={selectDisabled ? `Limit of ${selectionLimit} reached` : 'Final pick'}
            className={`left-3 disabled:opacity-40 disabled:cursor-not-allowed ${overlayButtonClass(isSelected)}`}
          >
            <CheckCircle2 className={`h-4 w-4 ${isSelected ? 'fill-current' : ''}`} />
          </button>
        </>
      )}
    </div>
  </Reveal>
);
